<template>
    <MasterTemplate 
        title="ข้อมูลหน้าจอการใช้งาน" 
        :headers="headers" 
        :setData="setData"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        :onOpenDialog="onOpenDialog"
        itemKey="pageId"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="6" >
                    <v-text-field label="รหัสหน้าจอ" v-model="editedItem.pageCode" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" >
                    <v-text-field  label="ชื่อหน้าจอ" v-model="editedItem.pageName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6" >
                    <v-text-field label="URL" v-model="editedItem.pageUrl"></v-text-field>
                </v-col>
                <v-col cols="6" >
                    <p>ประเภทหน้าจอ</p>
                    <v-radio-group v-model="editedItem.pageType" mandatory>
                        <v-radio label="ข้อมูลหลัก" value="M" ></v-radio>
                        <v-radio label="STOCK" value="S"></v-radio>
                        <v-radio label="Transaction" value="T"></v-radio>
                        <v-radio label="ใบแจ้งซ่อม" value="J"></v-radio>
                        <v-radio label="รายงาน" value="R"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <!--
            <v-row>
                <v-col cols="12">
                    <v-combobox
                        v-model="editedItem.pageFunction"
                        :items="items"
                        hide-selected
                        hint=""
                        label="เพิ่มฟังค์ชั่นหน้าจอ"
                        multiple
                        persistent-hint
                        small-chips
                        >
                        <template v-slot:no-data>
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                Enter เพื่อเพิ่มฟังค์ชั่น
                                </v-list-item-title>
                            </v-list-item-content>
                            </v-list-item>
                        </template>

                        <template v-slot:selection="{ attrs, item, parent, selected }">
                            <v-chip
                            v-bind="attrs"
                            :color="`${item.color} lighten-3`"
                            :input-value="selected"
                            label
                            small
                            >
                            <span class="pr-2">
                                {{ item.functionName }}
                            </span>
                            <v-icon
                                small
                                @click="parent.selectItem(item)"
                            >close</v-icon>
                            </v-chip>
                        </template>
                    </v-combobox>
                </v-col>
            </v-row>
            -->
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listPage, insert, update, deletePage} from '@/api/master/page-api.js'

export default {
    name: 'Page',
    components: {
        MasterTemplate
    },
    data: () => ({
        headers: [
            {text: 'รหัสหน้าจอ', value: 'pageCode'},
            {text: 'ชื่อหน้าจอ', value: 'pageName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            pageId: '',
            pageCode: '',
            pageName: '',
            pageUrl: '',
            pageType: 'M',
            pageFunction: []
        },
        items:[]
    }),
    watch: {
        'editedItem.pageFunction': function(val, prev) {
            if (!val || !prev) return;
            if (val.length === prev.length) return

            this.editedItem.pageFunction = val.map(v => {
            if (typeof v === 'string') {
                v = {
                    text: v,
                    functionName: v
                }
                this.items.push(v)
            }

            return v
            })
        }
    },
    methods: {
        listData() {
            return listPage();
        },
        deleteData(item) {
            return deletePage(item.pageId);
        },
        insertData() {
            return insert(this.editedItem);
        },
        updateData() {
            return update(this.editedItem);
        },
        getItemName(item) {
            return item.pageName;
        },
        setData(item) {
            this.editedItem = item;
        },
        onOpenDialog() {
            if (!this.editedItem.pageId) {
                this.editedItem.pageFunction = [{functionName: 'create'}, {functionName: 'update'}, {functionName: 'delete'}];
            }
            
        }
    }
}
</script>
